"use client";

import { useSelector } from "react-redux";
import { ProgressBar } from "staysure-component-library";

import withBrand from "@/components/with-brand";
import { RootState } from "@/store/store";

function Progress(
  props: Readonly<{
    brand?: "staysure" | "avanti";
  }>
) {
  const { brand } = props;
  const progress = useSelector((state: RootState) => state.progress);
  return (
    <header>
      {progress !== -1 && <ProgressBar value={progress} brand={brand} />}
    </header>
  );
}

export default withBrand(Progress);
